import { environment } from '../../environments/environment';
import type { AppLogLevel } from './app-logging';

export class AppEnvironment {
  static get apiBaseUrl(): string {
    return environment.apiBaseUrl;
  }

  static get arcgisAssetsBaseUrl(): string {
    return environment.arcgisAssetsBaseUrl;
  }

  static get entraClientId(): string {
    return environment.entraClientId;
  }

  static get entraTenantId(): string {
    return environment.entraTenantId;
  }

  static get entraRedirectUri(): string {
    return environment.entraRedirectUri;
  }

  static get entraApiScope(): string {
    return environment.entraApiScope;
  }

  static get defaultLogLevels(): Record<string, AppLogLevel> {
    return environment.defaultLogLevels;
  }

  static getWarnings(): readonly string[] {
    return environment.warnings;
  }
}
